import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as rocketchatApi from '@/api/rocketchat.api';

/**
 * Query keys for RocketChat
 */
export const rocketchatKeys = {
  all: ['rocketchat'] as const,
  status: () => [...rocketchatKeys.all, 'status'] as const,
};

/**
 * Fetch RocketChat connection status
 */
export function useRocketChatStatus() {
  return useQuery({
    queryKey: rocketchatKeys.status(),
    queryFn: () => rocketchatApi.getRocketChatStatus(),
    refetchInterval: 30000, // Refresh every 30 seconds
    retry: false,
  });
}

/**
 * Connect to RocketChat mutation
 */
export function useConnectRocketChat() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => rocketchatApi.connectRocketChat(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: rocketchatKeys.status() });
    },
  });
}
